import type { RefObject } from 'react';
import { revealRectangle } from 'util/animation/reveal/reveal';
import type { CaseCardRef } from 'components/blocks/case-card/CaseCard.data';
import { fadeFromTo } from 'util/animation/fade/fade';

interface CaseCarouselRefs {
  elementRef?: RefObject<HTMLElement | null>;
  caseCardsRef: RefObject<Array<CaseCardRef>>;
  buttonsContainerRef?: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { caseCardsRef, buttonsContainerRef }: CaseCarouselRefs,
): void {
  if (caseCardsRef?.current?.length > 0) {
    caseCardsRef.current.forEach((card) => {
      if (card?.elementRef?.current) {
        timeline.add(
          revealRectangle(card?.elementRef?.current, {
            from: 'bottom',
            duration: 0.5,
          }),
          '<25%',
        );
      }
    });
  }

  const buttons = buttonsContainerRef?.current?.querySelectorAll('button');
  if (buttons?.length) {
    timeline.add(
      fadeFromTo(Array.from(buttons), {
        duration: 0.4,
        stagger: 0.08,
      }),
      '<',
    );
  }
}

export function setupTransitionOutTimeline(): void {}
